module.exports = __webpack_public_path__ + "media/club_product_v2/11-a8ea01c7.webp";